import * as React from 'react';

import * as styles from './MarkdownColumnsWrapper.module.css';

interface Props {
  children: React.ReactNode;
}

export const MarkdownColumnsWrapper = ({ children }: Props) => (
  <div className={styles.wrapper}>{children}</div>
);
